import { render } from "./patientfooter.vue?vue&type=template&id=aa1f7aa4"
import script from "./patientfooter.vue?vue&type=script&lang=js"
export * from "./patientfooter.vue?vue&type=script&lang=js"

import "./patientfooter.vue?vue&type=style&index=0&id=aa1f7aa4&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__